import { AxiosResponse, AxiosRequestConfig } from 'axios';

import { Transfer } from '../../../types/transfer/Transfer';
import axiosInstance from '../../../utils/axiosInstance';
import { advancedTransferResponseTransformer } from '../../inventory/transfer/transformer';
import {
  V1_ADVANCED_INVENTORY_CREATE_INGREDIENTS_TRANSFER,
  V1_ADVANCED_INVENTORY_UPDATE_INGREDIENTS_TRANSFER,
  V1_ADVANCED_INVENTORY_GET_DETAIL_INGREDIENT_TRANSFER,
  V1_ADVANCED_INVENTORY_SUBMIT_SHIP_INGREDIENT,
  V1_ADVANCED_INVENTORY_SUBMIT_FULFILL_INGREDIENT,
} from './constants';
import {
  CreateIngredientsTransferRequest,
  UpdateIngredientsTransferRequest,
} from './types/requests';
import {
  GetDetailIngredientTransfertResponse,
  CreateIngredientsTransferResponse,
} from './types/responses';

export const postCreateIngredientsTransfer = async (
  data: CreateIngredientsTransferRequest,
  configs: AxiosRequestConfig
): Promise<AxiosResponse<CreateIngredientsTransferResponse>> => {
  return axiosInstance
    .post(V1_ADVANCED_INVENTORY_CREATE_INGREDIENTS_TRANSFER, data, configs)
    .catch((error) => {
      if (error.response) {
        const eobj = new Error(error.response.data.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(new Error(error.message));
    });
};

export const putUpdateIngredientsTransfer = async (
  id: number,
  data: UpdateIngredientsTransferRequest
): Promise<Transfer> => {
  return axiosInstance
    .put(V1_ADVANCED_INVENTORY_UPDATE_INGREDIENTS_TRANSFER(id), data)
    .then((res) => {
      const [transformedData] = advancedTransferResponseTransformer([
        res.data.data,
      ]);
      return transformedData;
    })
    .catch((error) => {
      if (error.response) {
        const [err] = error.response.data.errors;
        return Promise.reject(new Error(err.message));
      }
      return Promise.reject(new Error(error.message));
    });
};

export const getDetailIngredientTransfer = async (
  id: string
): Promise<AxiosResponse<GetDetailIngredientTransfertResponse>> => {
  const { data } = await axiosInstance
    .get(V1_ADVANCED_INVENTORY_GET_DETAIL_INGREDIENT_TRANSFER(id))
    .catch((error) => {
      if (error.response) {
        const eobj = new Error(error.response.data.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(new Error(error.message));
    });

  return data;
};

export const submitShipmentIngredient = async (params, headers) => {
  return axiosInstance
    .post(V1_ADVANCED_INVENTORY_SUBMIT_SHIP_INGREDIENT, params, headers)
    .catch((error) => {
      if (error.response) {
        const eobj = new Error(error.response.data.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(new Error(error.message));
    });
};

export const submitFulfillmentIngredient = async (params, headers) => {
  return axiosInstance
    .post(V1_ADVANCED_INVENTORY_SUBMIT_FULFILL_INGREDIENT, params, headers)
    .catch((error) => {
      if (error.response) {
        const eobj = new Error(error.response.data.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(new Error(error.message));
    });
};
